export * from './services';
export * from './translations';

// Firebase collection names
export const COLLECTIONS = {
  USERS: 'users',
  SERVICE_OFFERINGS: 'serviceOfferings',
  EXCHANGES: 'exchanges',
  MESSAGES: 'messages',
  RATINGS: 'ratings',
} as const;

// Community status thresholds
export const STATUS_THRESHOLDS = {
  NEW_NEIGHBOR: 0,
  HELPING_HAND: 1,
  LOCAL_CONNECTOR: 4,
  COMMUNITY_PILLAR: 7,
} as const;

// Payment preference display order
export const PAYMENT_PREFERENCES = [
  { key: 'cash', color: 'bg-yellow-100 text-yellow-800', icon: '💵' },
  { key: 'points', color: 'bg-green-100 text-green-700', icon: '⭐' },
  { key: 'no_preference', color: 'bg-gray-100 text-gray-700', icon: '✨' },
] as const;

// Default values
export const DEFAULTS = {
  LANGUAGE: 'fr' as const,
  PAGINATION_LIMIT: 20,
  MAX_MESSAGE_LENGTH: 500,
  MAX_BIO_LENGTH: 300,
  MAX_RATING: 5,
  MIN_RATING: 1,
} as const;
